module.exports = __webpack_public_path__ + "static/media/menu.47d85d7d.svg";